<template>
  <div>
    <div v-if="loading">
      <loader :loading="loading" />
    </div>
    <div v-else class="card p-3">
      <Section
        title="اطلاعات تمرین"
        subTitle="جزئیات ارسال تمرین"
        :extraTitle="practice.practiceDescription ? 'توضیحات تمرین ارسالی توسط دانش پذیر' : 'تمرین ارسالی توسط دانش پذیر'"
      >
        <template>
          <div v-if="practice.fullName" class="d-flex align-items-center gap-3 section_box">
            <p :class="['px-3 full_name', { full_name_with_delay: practice.delivery === 1 }]">{{ practice.fullName }}</p>

            <span data-bs-toggle="tooltip" :title="computeDate(practice.date)" :class="['delay_box', { with_delay: practice.delivery === 1 }]">
              {{ practice.delivery === 0 ? 'بدون تاخیر' : 'با تاخیر' }}
            </span>
          </div>
        </template>

        <template #extra_section>
          <div v-if="practice.practiceDescription" class="d-flex align-items-center gap-3 p-3 section_box">
            <p class="px-3 user_description" v-text="practice.practiceDescription" />
          </div>

          <div class="my-4">
            <div class="d-flex flex-wrap gap-5 align-items-center">
              <b-button v-if="practice.url" class="user_practice_btn" :disabled="downloadLoading" @click="downloadPracticeFile(practice.url)">
                <div class="d-flex align-items-center gap-2">
                  <i :class="[{ 'far fa-download': !downloadLoading }, { 'fas fa-spin fa-spinner': downloadLoading }]" style="color: rgba(29, 63, 168, 1)"> </i>

                  <span style="color: rgba(29, 63, 168, 1)">دانلود تمرین ارسال شده کاربر</span>
                </div>
              </b-button>

              <div v-if="practice.score" class="d-flex gap-3 align-items-center">
                <p style="margin: 0">نمره کسب شده</p>

                <div :class="['d-flex gap-1 align-items-center justify-content-center practice_rate', { practice_rate_with_delay: Number(practice.score) < 50 }]">
                  <p style="margin: 0; color: black">{{ practice.score }}</p>

                  <p style="margin: 0">⭐</p>
                </div>
              </div>
            </div>
          </div>
        </template>
      </Section>
    </div>

    <div class="card">
      <Section title="مشخصات درس" subTitle="اسم دوره" extraTitle="عنوان سرفصل">
        <template>
          <div v-if="practice.courseTitle" class="d-flex align-items-center gap-3 section_box">
            <p class="px-3 user_description">{{ practice.courseTitle }}</p>
          </div>
        </template>

        <template #extra_section>
          <div v-if="practice.courseSessionTitle" class="d-flex align-items-center gap-3 p-3 section_box">
            <p class="px-3 user_description">{{ practice.courseSessionTitle }}</p>
          </div>

          <div class="my-4">
            <p class="extra_section_title">توضیحات سرفصل</p>

            <div class="d-flex align-items-center gap-3 p-3 section_box">
              <span class="px-3 description user_description" v-html="practice.courseSessionDescription" />
            </div>
          </div>

          <div class="my-4">
            <p class="extra_section_title">عنوان فعالیت</p>

            <div practice.title class="d-flex align-items-center gap-3 p-3 section_box">
              <span class="px-3 description user_description" v-text="practice.title" />
            </div>
          </div>

          <div v-if="practice.description && practice.description.length > 34" class="my-4">
            <p class="extra_section_title">توضیحات فعالیت</p>

            <div class="d-flex align-items-center gap-3 p-3 section_box">
              <span class="px-3 description user_description" v-html="practice.description" />
            </div>
          </div>

          <div practice.fileUrl class="my-4 d-flex align-items-center gap-3">
            <p style="font-size: 17px" class="extra_section_title">فایل پروژه</p>

            <b-button class="practice_file_download_btn" :disabled="downloadLoading" @click="downloadPracticeFile(practice.fileUrl)">
              <div class="d-flex align-items-center gap-2">
                <i :class="[{ 'far fa-download': !downloadLoading }, { 'fas fa-spin fa-spinner': downloadLoading }]" style="color: rgba(29, 63, 168, 1); font-size: 17px"> </i>

                <span style="font-size: 17px" class="practice_file_download_btn_text">دانلود فایل</span>
              </div>
            </b-button>
          </div>
        </template>
      </Section>

      <div>
        <p v-if="practice.statusFullName && practice.statusUserId" style="color: rgba(52, 195, 143, 1); font-weight: 700; font-size: 15px" class="p-3">
          {{ ` ${practice.statusFullName} به یورز نیم (${practice.statusUserId}) وضعیت تمرین کاربر را اپدیت نموده است.` }}
        </p>
      </div>
    </div>

    <div class="d-flex align-items-center justify-content-end gap-3 my-4">
      <b-button variant="primary" @click="$bvModal.show('edit')">نیاز به اصلاح</b-button>

      <b-button @click="$bvModal.show('accept')" variant="success">تایید تمرین</b-button>
    </div>

    <b-modal id="edit" no-close-on-esc hide-footer centered header-close-variant="dark" cancel-title>
      <template #modal-title>نیاز به اصلاح</template>
      <div>
        <TextAreaInput
          v-model="practice.statusDescription"
          title="ثبت گزارش"
          required
          :showError="submit && !practice.statusDescription"
          errortext="فیلد ثبت گزارش الزامی است."
          textAreaClass="align-items-center"
          titleStyle="align-self: baseline;"
          rows="10"
        />
        <div class="pt-3 pb-0 d-flex flex-row justify-content-end">
          <b-button @click="$bvModal.hide('edit'), (submit = false)">انصراف</b-button>

          <b-button variant="primary ms-2 px-5" @click="practiceAction('edit')">ثبت</b-button>
        </div>
      </div>
    </b-modal>

    <b-modal id="accept" no-close-on-esc hide-footer centered header-close-variant="dark" cancel-title>
      <template #modal-title>تایید تمرین</template>
      <div class="d-flex flex-column gap-4" style="height: 70px">
        <div class="d-flex align-items-center gap-3 slider">
          <label style="margin: 0">نمره درصدی کاربر</label>
          <vue-slider ref="slider" v-model="practiceScore" v-bind="sliderOptions"></vue-slider>
        </div>

        <label v-if="submit && checkPracticeRate" style="color: rgba(244, 106, 106, 1)">وارد کردن نمره برای کاربر اجباری می باشد.</label>
      </div>

      <div>
        <TextAreaInput v-model="practice.statusDescription" title="ثبت گزارش" textAreaClass="align-items-center" titleStyle="align-self: baseline;" rows="10" />

        <div class="pt-3 pb-0 d-flex flex-row justify-content-end">
          <b-button @click="$bvModal.hide('accept'), (practiceScore = 0), (submit = false)">انصراف</b-button>

          <b-button variant="primary ms-2 px-5" @click="practiceAction('accept')">ثبت</b-button>
        </div>
      </div>
    </b-modal>

    <toast error :showToast="showToast" title="کاربر گرامی شما دسترسی ایجاد تغییر در تمرین کاربران را ندارید." />
  </div>
</template>

<script>
import moment from 'jalali-moment'
import VueRangeSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import TextAreaInput from '../../../components/common/form/formModules/TextAreaInput.vue'
import Section from '../../../components/common/form/Section.vue'
import loader from '../../../components/common/loader.vue'
import skillUpCourseProvider from '../../../services/skillUp/course.js'
import Toast from '../../../components/common/Toast.vue'

export default {
  components: { Section, loader, TextAreaInput, vueSlider: VueRangeSlider, Toast },
  data() {
    return {
      showToast: false,
      loading: false,
      practiceScore: 0,
      downloadLoading: false,
      practice: {},
      checkPracticeRate: false,
      submit: false,
      sliderOptions: {
        dotSize: 0,
        width: '100%',
        height: 7,
        contained: false,
        direction: 'rtl',
        dataLabel: 'label',
        dataValue: 'value',
        min: 0,
        max: 100,
        interval: 5,
        disabled: false,
        clickable: true,
        duration: 1,
        adsorb: false,
        lazy: true,
        tooltip: 'always',
        tooltipPlacement: 'top',
        useKeyboard: false,
        keydownHook: null,
        dragOnClick: true,
        enableCross: true,
        fixed: false,
        order: true,
        marks: {
          0: '0',
          100: '100',
        },
        process: true,
        processStyle: { backgroundColor: '#556ee6' },
        tooltipStyle: { backgroundColor: '#556ee6', borderColor: '#556ee6', height: '25px', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2px 1px' },
      },
    }
  },
  methods: {
    computeDate(date) {
      // const date = new Date()
      // const today = date.toLocaleDateString()
      console.log(date, moment(date).local('fa').format('MM:HH YYYY/MM/D'))
      return moment(date).locale('fa').format('HH:MM YYYY/MM/DD ')
    },
    async practiceAction(act) {
      this.submit = true
      const payload = {
        description: this.practice.statusDescription,
        licenseStatus: act === 'accept' ? 4 : 2,
        id: +this.$route.params.practiceId,
        score: act === 'accept' ? +this.practiceScore : undefined,
      }
      if (act === 'edit') {
        if (!this.practice.statusDescription) return false
      } else {
        if (!this.practiceScore) {
          this.checkPracticeRate = !this.practiceScore ? true : false
          return false
        }
      }
      try {
        const req = await skillUpCourseProvider.editPracticeStatus(payload)
        if (req.data.data.isSuccessful) {
          if (this.$route.path.includes('teacherskilluppractice')) this.$router.push('/list/teacherskilluppractice')
          else this.$router.push('/list/skilluppractice')
        } else {
          this.showToast = false
          this.$nextTick(() => {
            this.showToast = true
          })
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.$bvModal.hide(act)

        this.practiceScore = 0
      }
    },
    downloadPracticeFile(href) {
      this.downloadLoading = true
      setTimeout(() => {
        window.open(href, '_blank')
      }, 1000)
      setTimeout(() => {
        this.downloadLoading = false
      }, 1000)
    },
    async fetchPractice() {
      try {
        this.loading = true
        const req = await skillUpCourseProvider.getPractice(+this.$route.params.practiceId)
        this.practice = req.data.data.output
      } finally {
        this.loading = false
      }
    },
  },
  async mounted() {
    await this.fetchPractice()
    this.practiceScore = this.practice.score
  },
}
</script>

<style scoped lang="scss">
.extra_section_title {
  white-space: nowrap;
  font-style: normal;
  font-weight: normal;
  margin-bottom: 0;
  font-size: 14px;
  line-height: 23px;
  text-align: right;
  color: #556ee6;
}

::v-deep .description p {
  margin: 0 !important;
}

::v-deep .mainButton {
  border-radius: 0.25rem;
}

::v-deep .slider .vue-slider {
  width: 77% !important;
}

.section_box {
  background: rgba(248, 249, 250, 1);
  border-radius: 5px;
}

.full_name {
  margin: 0;
  font-size: 17px;
  color: rgba(52, 195, 143, 1);
}

.full_name_with_delay {
  color: #f46a6a;
}

.delay_box {
  padding: 0.2rem 0.5rem;
  border-radius: 1rem;
  background: white;
  border: 1px solid rgba(52, 195, 143, 1) !important;
  color: rgba(52, 195, 143, 1);
}

.practice_rate_with_delay {
  border-color: rgba(244, 106, 106, 1) !important;
  background-color: rgba(244, 106, 106, 1) !important;
  color: rgba(244, 106, 106, 1) !important;
}

.with_delay {
  border-color: rgba(244, 106, 106, 1) !important;
  color: rgba(244, 106, 106, 1) !important;
}

.user_description {
  margin: 0;
  font-size: 17px;
}

.user_practice_btn {
  background: rgba(85, 110, 230, 0.15);
  border-color: rgba(85, 110, 230, 0.15);
  &:focus {
    box-shadow: none;
  }
}

::v-deep .btn:first-child:active {
  background: rgba(85, 110, 230, 0.15) !important;
  border-color: rgba(85, 110, 230, 0.15) !important;
}

.practice_rate {
  padding: 0.2rem 0.5rem;
  border: 1px solid rgba(52, 195, 143, 1);
  border-radius: 1rem;
  background: rgba(76, 225, 182, 0.17);
  color: rgba(52, 195, 143, 1);
  width: 60px;
}

.practice_file_download_btn {
  background: white;
  border-color: white;
  &:focus {
    box-shadow: none;
  }
}

.practice_file_download_btn_text {
  color: rgba(29, 63, 168, 1);
}

@media (min-width: 280px) and (max-width: 330px) {
  .section_box {
    gap: 0.2rem !important;
  }
  .full_name {
    padding: 0 !important;
    font-size: 12px;
    width: 100px;
  }

  .delay_box {
    font-size: 10px;
    width: 58%;
    text-align: center;
  }

  ::v-deep .sectionTitle {
    white-space: pre-wrap !important;
    font-size: 12px;
  }

  .user_description {
    font-size: 14px;
    white-space: pre-wrap;
  }

  .extra_section_title {
    white-space: pre-wrap !important;
    font-size: 12px;
  }
}

@media (min-width: 330px) and (max-width: 440px) {
  .section_box {
    gap: 0.2rem !important;
  }

  .full_name {
    font-size: 14px;
    width: 90%;
    padding: 0 !important;
  }

  .delay_box {
    width: 60%;
    text-align: center;
  }
}
</style>
